import React from "react";

import NoComponents from "../../../../../assets/images/perspectives/nothing-found.svg?react";
import { FullCenterViewLayout, type FullCenterViewLayoutProps } from "../full-center-view-layout/FullCenterViewLayout";

type NotFoundProps = Omit<FullCenterViewLayoutProps, "image" | "content">;

export const NotFound: React.FC<React.PropsWithChildren<NotFoundProps>> = ({ children, ...props }) => (
	<FullCenterViewLayout
		content={children}
		image={
			<div className="h-[143px] max-h-full w-[321px] max-w-full">
				<NoComponents className="h-full w-full" />
			</div>
		}
		noShadow
		{...props}
	/>
);
